
import React from 'react';

// export const TableColumn = ({ title, children }) => {
//   return (
//     <th className="px-4 py-2 bg-gray-100 dark:bg-gray-800 border-b text-right">
//       <div className="font-semibold">{title}</div>
//       {children}
//     </th>
//   );
// };

export const TableHeader = ({ children }) => {
  return <>
    <thead className="block md:table-header-group">
      {children}
    </thead>
  </>;
};

export const TableBody = ({ children }) => {
  return (
    <tbody className="block md:table-row-group">
      {children}
    </tbody>
  );
};

export const TableRow = ({ children }) => {
  return (
    <tr className="border-b border-gray-200 dark:border-gray-700 block md:table-row">
      {children}
    </tr>
  );
};

export const TableColumn = ({ children, mobile = false, desktop = true }) => {
  return (
    <td scope="col" className={`[&.mobile]:hidden [&.desktop]:block [&.desktop]:md:table-cell md:whitespace-nowrap px-3 py-3.5 text-start text-sm font-semibold text-gray-900 dark:text-gray-300 [&:last-child]:sticky [&:last-child]:left-0 ${mobile ? 'mobile' : 'desktop'}`}>
      {children}
    </td>
  );
};

export const TableData = ({ title, children, total, size, page, setPage }) => {
  const totalPages = Math.ceil(total / size) || 1;
  
  // Generate page options with smart limiting for large page counts
  const generatePageOptions = () => {
    const options = new Set();
    
    // Always include first 10 pages
    for (let i = 1; i <= Math.min(10, totalPages); i++) {
      options.add(i);
    }
    
    // Include pages within distance 10 of current page
    for (let i = Math.max(1, page - 10); i <= Math.min(totalPages, page + 10); i++) {
      options.add(i);
    }
    
    // Always include last 10 pages
    for (let i = Math.max(1, totalPages - 9); i <= totalPages; i++) {
      options.add(i);
    }
    
    return Array.from(options).sort((a, b) => a - b);
  };
  
  const pageOptions = generatePageOptions();
  
  return <div className="flex flex-col gap-2 w-full max-w-full">
    <div className="w-full max-w-full overflow-hidden border border-gray-200 dark:border-gray-700 rounded-lg">
      <div className="w-full overflow-x-auto overflow-y-hidden">
        <table className="min-w-full table-auto">
          {children}
        </table>
      </div>
    </div>
    <div className="flex flex-col md:flex-row md:justify-between gap-3">
      {/* Results and navigation */}
      <div className="flex flex-col md:flex-row items-center gap-2">
        <span className="text-sm text-gray-700 dark:text-gray-400 text-center md:text-right">
          نمایش {Math.min((page - 1) * size + 1, total) || 0} تا {Math.min(page * size, total) || 0} از <strong>{total?.toLocaleString() || 0}</strong> نتیجه
        </span>
        
        <div className="flex items-center gap-2 w-full md:w-auto">
          <button
            onClick={() => setPage(page - 1)}
            disabled={page <= 1}
            className="flex-1 md:flex-none inline-flex justify-center items-center rounded-md px-3 py-2 text-sm font-semibold text-gray-900 dark:text-gray-300 ring-1 ring-inset ring-gray-300 dark:ring-gray-700 hover:bg-gray-50 dark:hover:bg-gray-800 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <svg className="w-4 h-4 ml-1 md:hidden" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
            قبلی
          </button>
          
          <select 
            value={page}
            onChange={(e) => setPage(parseInt(e.target.value))}
            className="flex-1 md:flex-none text-center rounded-md px-3 py-2 text-sm font-semibold text-gray-900 dark:text-gray-300 bg-white dark:bg-gray-900 ring-1 ring-inset ring-gray-300 dark:ring-gray-700 hover:bg-gray-50 dark:hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400"
          >
            {pageOptions.map((pageNum, index) => {
              const prevPage = pageOptions[index - 1];
              const showSeparator = prevPage && pageNum - prevPage > 1;
              return (
                <React.Fragment key={pageNum}>
                  {showSeparator && <option disabled>───</option>}
                  <option value={pageNum}>
                    <span className="hidden md:inline">صفحه </span>{pageNum} / {totalPages}
                  </option>
                </React.Fragment>
              );
            })}
          </select>
          
          <button
            onClick={() => setPage(page + 1)} 
            disabled={page * size >= total}
            className="flex-1 md:flex-none inline-flex justify-center items-center rounded-md px-3 py-2 text-sm font-semibold text-gray-900 dark:text-gray-300 ring-1 ring-inset ring-gray-300 dark:ring-gray-700 hover:bg-gray-50 dark:hover:bg-gray-800 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            بعدی
            <svg className="w-4 h-4 mr-1 md:hidden" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
        </div>
      </div>
      
      {/* Page size selector */}
      <div className="flex items-center justify-center md:justify-end gap-2">
        <span className="text-sm text-gray-600 dark:text-gray-400 md:hidden">تعداد:</span>
        {[5, 10, 20, 50, 100].map((newSize) => (
          <button
            key={newSize}
            onClick={() => setPage(1, newSize)}
            disabled={size === newSize}
            className="hidden md:inline-flex items-center rounded-md px-3 py-2 text-sm font-semibold text-gray-900 dark:text-gray-300 ring-1 ring-inset ring-gray-300 dark:ring-gray-700 hover:bg-gray-50 dark:hover:bg-gray-800 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {newSize}
          </button>
        ))}
        <select 
          value={size}
          onChange={(e) => setPage(1, parseInt(e.target.value))}
          className="md:hidden rounded-md px-3 py-1 text-sm font-semibold text-gray-900 dark:text-gray-300 bg-white dark:bg-gray-900 ring-1 ring-inset ring-gray-300 dark:ring-gray-700 hover:bg-gray-50 dark:hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400"
        >
          {[5, 10, 20, 50, 100].map((newSize) => (
            <option key={newSize} value={newSize}>{newSize}</option>
          ))}
        </select>
      </div>
    </div>
  </div>;
}; 

export const EditableSlideToggle = ({  }) => <div>
  <input className="w-4 h-4 rounded-md border border-gray-300" type="checkbox" />
</div>;